import { render } from "./MakeAppointment.vue?vue&type=template&id=23a2c7ce&scoped=true"
import script from "./MakeAppointment.vue?vue&type=script&lang=js"
export * from "./MakeAppointment.vue?vue&type=script&lang=js"

import "./MakeAppointment.vue?vue&type=style&index=0&id=23a2c7ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a2c7ce"]])

export default __exports__